import type { FunctionComponent } from 'react'

import { COLORS, H4Flow } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { DebtItem } from '../debtItem'

const ErrorListItem = styled.li`
	color: ${COLORS.OTHER_COLORS.ERROR_RED};
	font-weight: 600;
	font-size: 15px;
`
const ErrorList = styled.ul`
	margin-top: 5px;
`
const ErrorHeader = styled(H4Flow)`
	color: ${COLORS.OTHER_COLORS.ERROR_RED};
	margin-bottom: 0;
`
export const DebtItemErrors: FunctionComponent<{ item: DebtItem }> = ({
	item,
}) => {
	const { debtPayment, debtRecords } = item
	const errors: string[] = []
	const { t } = useTranslation()

	if (
		debtRecords.some(
			(dr) => dr.principalAmount == null || dr.principalAmount <= 0,
		)
	) {
		errors.push(t('debtOverview-outstanding-amount-validation'))
	}

	if (
		typeof debtPayment.paymentAmount !== 'number' ||
		debtPayment.paymentAmount < 0
	) {
		errors.push(t('debtOverview-monthly-installment-validation'))
	}

	if (errors.length > 0) {
		return (
			<>
				<ErrorHeader>{t('validation-fieldRequired')}</ErrorHeader>
				<ErrorList>
					{errors.map((error) => (
						<ErrorListItem key={error}>{error}</ErrorListItem>
					))}
				</ErrorList>
			</>
		)
	}
	return null
}
